/**
 * format battery values
 *
 */

function numberFormatterBattery(val) {
  if (!val) return val;

  if (Number.isInteger(val)) {
    return val;
  } else if (isNaN(val)) {
    return val;
  } else {
    if (val < 1) {
      // two decimal places  ex. 0.99 kWh or 0.98 kWh
      return val.toFixed(2);
    }
    // one decimal places  5.3 kWh
    return val.toFixed(1);
  }
}

function formatValue(val) {
  if (!val) {
    return 0;
  } else if (isNaN(val)) {
    return val;
  } else {
    val = Number(val);
    val /= 1000;
    val = Math.abs(val);
    return val;
  }
}

function formatValueWithUnit(unit, value) {
  let formattedValue = Number(numberFormatterBattery(formatValue(value))).toLocaleString('de-DE');
  if (isNaN(Number(numberFormatterBattery(formatValue(value))))) formattedValue = '--';
  return `${formattedValue} <span class="unit">${unit}</span>`;
}

export default formatValueWithUnit;
